/**
 * 상품 목록 로딩 스켈레톤
 *
 * loading.tsx에서 사용 — 서버 컴포넌트로도 사용 가능
 */

function SkeletonCard() {
  return (
    <div className="rounded-sm border bg-card overflow-hidden animate-pulse">
      <div className="aspect-square bg-muted" />
      <div className="p-4 flex flex-col gap-2">
        <div className="h-4 w-16 bg-muted rounded" />
        <div className="h-4 w-3/4 bg-muted rounded" />
        <div className="h-5 w-1/2 bg-muted rounded mt-2" />
      </div>
    </div>
  );
}

interface ProductListSkeletonProps {
  count?: number;
}

export function ProductListSkeleton({ count = 8 }: ProductListSkeletonProps) {
  return (
    <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
      {Array.from({ length: count }).map((_, i) => (
        <SkeletonCard key={i} />
      ))}
    </div>
  );
}
